var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "facebook_1_",
    "data-name": "facebook (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_37297",
    "data-name": "Path 37297",
    d: "M20,10a10,10,0,0,1-8.437,9.879V12.891h2.33L14.336,10H11.563V8.124a1.445,1.445,0,0,1,1.63-1.562h1.261V4.1a15.381,15.381,0,0,0-2.239-.2A3.529,3.529,0,0,0,8.438,7.8V10H5.9v2.891H8.438v6.988A10,10,0,1,1,20,10Z",
    fill: "#1877f2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37298",
    "data-name": "Path 37298",
    d: "M158.994,108.984l.443-2.891h-2.773v-1.876a1.445,1.445,0,0,1,1.63-1.562h1.261V100.2a15.377,15.377,0,0,0-2.238-.2,3.529,3.529,0,0,0-3.777,3.891v2.2H151v2.891h2.539v6.988a10.106,10.106,0,0,0,3.125,0v-6.988Z",
    transform: "translate(-145.102 -96.094)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.caf9e7da80bda614038b27875e80e6d9.svg";
export { ForwardRef as ReactComponent };